import { T } from '@homeschooling/sdk'

import m from 'moment'
import * as React from 'react'
import * as _ from 'lodash'

//import  ScheduleTile from "../../Components/Schedule/ScheduleTile"
import ScheduleDay from './ScheduleDay'
import { Caret} from '../../Components/Icons'

import Persistance from "../Persistence";

export interface Props {
    children?: React.ReactNode
    schedule: T.ScheduleDay[]
    start_date: string
    end_date: string
    updateCal: (start_date: string, end_date: string, focus: string) => void
    updateNote: (note: T.Progress) => void
    updateExpense: (expense: T.Expense) => void
    focus: string
}
  
export interface State {
    students: T.Student[]
    focus: string
}

Persistance.setValues()

export class Calendar extends React.Component<Props, any> {

    public constructor (props: Props) {
        super(props)
    
        let focus = m()
        if (this.props.focus) {
            focus = m(this.props.focus)
        } else if( focus.isSameOrAfter(m(this.props.start_date)) && focus.isSameOrBefore(m(this.props.end_date))){
            //console.log('in if')
            //focus = focus
        }else {
            focus = m(this.props.start_date)
        }

        this.state = {
          students: Persistance.getStudents(),
          focus: focus.format('YYYY-MM-DD')
        }
      }  

  public forwardFocus = async () => {
    let current = m(this.state.focus)
    let next = current.add(1, 'day')
    
    if(next.isAfter(this.props.end_date)) {
        let newStart = m(next)
        let newEnd = next.add('34', 'days')
        await this.props.updateCal(newStart.format('YYYY-MM-DD'), newEnd.format('YYYY-MM-DD'), newStart.format('YYYY-MM-DD'))
        this.setState({focus: newStart.format('YYYY-MM-DD')})
    } else {
       this.setState({focus: next.format('YYYY-MM-DD')}) 
    }
  }
  
  public prevFocus = async () => {
    let current = m(this.state.focus)
    let last = current.subtract(1, 'day')
 
    if(last.isBefore(this.props.start_date)) {
        let newEnd = m(last)
        let newStart = last.subtract('34', 'days')
        await this.props.updateCal(newStart.format('YYYY-MM-DD'), newEnd.format('YYYY-MM-DD'), newEnd.format('YYYY-MM-DD'))
        this.setState({focus: newEnd.format('YYYY-MM-DD')})
    } else {
       this.setState({focus: last.format('YYYY-MM-DD')}) 
    }
  }

  public setFocus = (date: string) => {
    this.setState({focus: date})
  }  

  public getFocusEvent = () => {
    let focus = this.state.focus ? this.state.focus : this.props.start_date

    let day: T.ScheduleDay = _.find(this.props.schedule, {date: focus}) as T.ScheduleDay

    if(!day) {
        return(<div>Day not found</div>)
    }

    let rightCaret = (<div className='rotate-90 hover:cursor-pointer' onClick={async () => await this.forwardFocus()}><Caret size='medium' className='fill-slate-100'/></div>)
    let leftCaret = (<div className='-rotate-90 hover:cursor-pointer' onClick={async () => await this.prevFocus()}><Caret size='medium' className='fill-slate-100'/></div>)
    
    //let events = day?.events
    let display = []

    display.push(
        <div className='bg-gray-700 py-2 flex flex-none flex-row'>
            <div className='flex-none align-middle'>
                {leftCaret}
            </div>
            <div className='grow text-xl capitalize text-center font-bold text-white'>
                {m(day.date).format('DD MMM YYYY')}
            </div>
            <div className='flex-none align-middle'>
                {rightCaret}
            </div> 
        </div>
        
        )

    display.push(<ScheduleDay
            schedule={day}
            showDate={false}
            updateNote={(note: T.Progress) => this.props.updateNote(note)}
            updateExpense={(expense: T.Expense) => this.props.updateExpense(expense)}
            updateSchedule={() => this.props.updateCal(this.props.start_date, this.props.end_date, this.props.focus)}
        />)

    return (<div className='focus-event-box w-full h-full flex flex-col items-strecth'>{display}</div>
    )
  }

  public makeMonth = () => {
    let days = this.props.schedule

    let display = []

    for(let s of days){
        let month = m(s.date).format('DD') === '01' || this.props.schedule.indexOf(s) === 0 ? '' : 'hidden'
        let numberColor = m(s.date).isSame(m(), 'day') ? 'text-primary-400' : 'text-gray-300';
        numberColor = m(s.date).isSame(this.state.focus, 'day') ? 'text-white' : numberColor
        let background = m(s.date).isSame(this.state.focus, 'day') ? 'bg-primay-400' : 'bg-white'

        display.push(<div id={`cal_box_${s.date}`} onClick={() => this.setFocus(s.date)}className={`@container aspect-square ${background} relative hover:cursor-pointer`}>
                <div className='w-full h-full top-0 left-0 flex pt-[25%] place-content-center'>
                    {<div className='h-2 lg:h-4 w-auto text-center'>
                        <div className='font-medium text-l lg:text-xl'>{s.events.length > 0 ? s.events.length : '-'}</div>
                        <div className='font-thin hidden text-xs lg:text-s'>Events</div>
                    </div>}
                </div>
                <div className={`absolute bottom-0 ${month} text-gray-400 left-0 h-auto w-auto text-[2cqw] lg:text-xl uppercase pl-1 -z-0`}>
                    <div className='w-full border-b text-center'>
                        {m(s.date).format('MMM')}
                    </div>
                    <div className='w-full border-b text-center'>
                        {m(s.date).format('YYYY')}
                    </div>
                    
                </div>
                <div className={`absolute bottom-0 ${numberColor} right-0 h-auto w-auto text-[3cqw] text-right -z-60`}>
                    {m(s.date).format('DD')}
                </div>
            </div>)
    }

    return display
  }  

  public render(): React.ReactNode {
    
    return (
    <div id={`calendar`} className='w-full flex flex-col lg:flex-row'>
    <div className='w-auto grow bg-gray-200 border'>
        <div className='w-full grid gap-px grid-cols-7'>
            <div className='w-full text-l font-medium text-center'>
                Sun
            </div>
            <div className='w-full text-l font-medium text-center'>
                Mon
            </div>
            <div className='w-full text-l font-medium text-center'>
                Tue
            </div>
            <div className='w-full text-l font-medium text-center'>
                Wed
            </div>
            <div className='w-full text-l font-medium text-center'>
                Thu
            </div>
            <div className='w-full text-l font-medium text-center'>
                Fri
            </div>
            <div className='w-full text-l font-medium text-center'>
                Sat
            </div>
        </div>
        <div className='w-full grid gap-px grid-cols-7'> 
           {this.makeMonth()}
        </div>
    </div>
    <div className='w-full mt-2 lg:mt-0 lg:w-112 flex-none'>
        {this.getFocusEvent()}
    </div>
</div>
    )
  }  
  
}

export default Calendar